// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Matching ("Сбор") — panel, board card, form pieces. Uses the tavern theme variables. */

.matching-panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-1, 4px);
  width: 100%;
  padding: var(--space-3, 12px) var(--space-4, 16px);
  text-align: left;
  font: inherit;
  color: var(--color-text-primary-light, #f5e9d3);
  background: var(--color-wood-800, #3a2a18);
  border: 2px solid var(--color-wood-700, #5a4129);
  border-radius: var(--radius-lg, 12px);
  cursor: pointer;
}

.matching-panel--disabled {
  cursor: default;
  opacity: 0.6;
}

/* Clickable variant: raised look, chevron and press feedback so it reads as a button. */
.matching-panel--action {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3, 12px);
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  transition:
    transform 0.1s ease,
    box-shadow 0.1s ease,
    filter 0.1s ease;
}

.matching-panel__body {
  display: flex;
  flex-direction: column;
  gap: var(--space-1, 4px);
  min-width: 0;
}

.matching-panel__chevron {
  flex-shrink: 0;
  font-size: 28px;
  line-height: 1;
  opacity: 0.7;
}

@media (hover: hover) {
  .matching-panel--action:hover {
    filter: brightness(1.1);
  }
}

.matching-panel--action:active {
  transform: translateY(1px);
  filter: brightness(0.95);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.matching-panel--action:focus-visible {
  outline: 2px solid var(--color-fire-500, #e8892b);
  outline-offset: 2px;
}

.matching-panel--active {
  border-color: var(--color-fire-500, #e8892b);
}

.matching-panel--matched {
  border-color: var(--color-warning-500, #d9a520);
}

.matching-panel--formed {
  border-color: var(--color-success-500, #4a9d5b);
}

.matching-panel__title {
  font-family: var(--font-heading, inherit);
  font-weight: 700;
}

.matching-panel__text {
  font-size: 14px;
  opacity: 0.9;
}

/* ---------- request card ---------- */

.matching-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
  padding: var(--space-3, 12px);
  color: var(--color-text-primary, #1a1410);
}

.matching-card__top {
  display: flex;
  align-items: center;
  gap: var(--space-2, 8px);
}

.matching-card__author {
  flex: 1 1 auto;
  min-width: 0;
}

.matching-card__link {
  color: var(--color-fire-600, #b8470e);
  text-decoration: none;
}

.matching-card__link:hover {
  text-decoration: underline;
}

.matching-card__meta {
  font-size: 13px;
  color: var(--color-text-secondary, #4f3d2d);
}

.matching-card__when {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--space-2, 8px);
}

.matching-card__when .tavern-card-time {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
}

.matching-card__when .event-card-actions {
  flex: 0 0 auto;
  margin-left: auto;
}

@media (max-width: 360px) {
  .matching-card__when .tavern-card-time {
    padding: 4px 6px;
    font-size: 12px;
  }
}

.matching-card__prefs {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
}

.matching-card__pref-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: var(--space-2, 8px) var(--space-3, 12px);
  border-left: 4px solid var(--color-wood-600, #4f3d2d);
  border-radius: var(--radius-md, 8px);
  background: rgba(62, 47, 34, 0.06);
}

.matching-card__pref-group--want {
  border-left-color: var(--color-success-500, #4a7c59);
  background: rgba(74, 124, 89, 0.12);
}

.matching-card__pref-group--acceptable {
  border-left-color: var(--color-warning-500, #d4a74a);
  background: rgba(212, 167, 74, 0.14);
}

.matching-card__pref-group--exclude {
  border-left-color: var(--color-danger-500, #a8342a);
  background: rgba(168, 52, 42, 0.1);
}

.matching-card__pref-title {
  font-family: var(--font-heading, inherit);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.matching-card__pref-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2, 8px);
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.matching-card__pref-toggle:focus-visible {
  outline: 2px solid var(--color-fire-500, #d85a1f);
  outline-offset: 2px;
}

.matching-card__pref-count {
  display: inline-block;
  margin-left: 8px;
  min-width: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--color-fire-700, #8f3a0b);
  color: var(--color-parchment-100, #f5efe7);
  font-size: 12px;
  text-align: center;
}

.matching-card__pref-arrow {
  flex: 0 0 auto;
  font-size: 12px;
  line-height: 1;
}

.matching-card__pref-hint {
  font-family: var(--font-body, inherit);
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: var(--color-text-secondary, #4f3d2d);
}

.matching-card__pref-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.matching-card__pref-section + .matching-card__pref-section {
  margin-top: var(--space-1, 4px);
  padding-top: var(--space-2, 8px);
  border-top: 1px dashed var(--color-wood-600, #4f3d2d);
}

.matching-card__pref-caption {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-secondary, #4f3d2d);
}

.matching-card__pref-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.matching-card__pref-games {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
}

.matching-card__pref-chip {
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid var(--color-wood-600, #4f3d2d);
  background: var(--color-parchment-100, #f5efe7);
  color: var(--color-text-primary, #1a1410);
  font-size: 13px;
}

.matching-card__pref-chip--tag {
  background: var(--color-parchment-200, #e8dbc8);
  font-style: italic;
}

.matching-card__actions {
  display: flex;
  gap: var(--space-2, 8px);
  flex-wrap: wrap;
}

.matching-card__hint {
  font-size: 13px;
  color: var(--color-text-secondary, #4f3d2d);
}

/* ---------- preference picker ---------- */

.matching-prefs {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
}

.matching-prefs__summary {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
  padding: var(--space-3, 12px) var(--space-4, 16px);
  border-radius: var(--radius-lg, 12px);
  border: 2px solid var(--color-fire-700, #8f3a0b);
  background: var(--color-wood-800, #2d2218);
  color: var(--color-parchment-200, #e8dbc8);
}

.matching-prefs__summary .ttbFieldLabel {
  color: var(--color-parchment-100, #f5efe7);
}

.matching-prefs__summary-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2, 8px);
}

.matching-prefs__summary-level {
  flex: 0 0 96px;
  font-weight: 700;
}

.matching-prefs__summary-empty {
  opacity: 0.6;
}

.matching-prefs__group {
  display: flex;
  flex-direction: column;
  border: none;
  border-radius: var(--radius-lg, 12px);
  background: var(--color-wood-700, #3e2f22);
  color: var(--color-parchment-200, #e8dbc8);
  overflow: hidden;
}

.matching-prefs__group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2, 8px);
  width: 100%;
  padding: var(--space-3, 12px) var(--space-4, 16px);
  border: none;
  background: var(--color-wood-600, #4f3d2d);
  color: var(--color-parchment-100, #f5efe7);
  font: inherit;
  font-family: var(--font-heading, inherit);
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: left;
  cursor: pointer;
}

.matching-prefs__group-header:hover {
  background: var(--color-wood-600, #4f3d2d);
  box-shadow: inset 0 0 0 100px rgba(245, 239, 231, 0.07);
}

.matching-prefs__group-header:focus-visible {
  outline: 2px solid var(--color-fire-500, #d85a1f);
  outline-offset: -2px;
}

.matching-prefs__arrow {
  flex: 0 0 auto;
  font-size: 14px;
  line-height: 1;
}

.matching-prefs__count {
  display: inline-block;
  margin-left: 8px;
  min-width: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--color-fire-700, #8f3a0b);
  color: var(--color-parchment-100, #f5efe7);
  font-size: 13px;
  text-align: center;
}

.matching-prefs__group-body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3, 12px);
  padding: var(--space-3, 12px);
}

.matching-prefs__group .ttbFieldHint,
.matching-prefs__group .ttbFieldLabel {
  color: var(--color-parchment-200, #e8dbc8);
}

.matching-prefs__zone {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
  padding: var(--space-2, 8px) var(--space-3, 12px);
  border-radius: var(--radius-md, 8px);
  border: 2px solid var(--color-wood-600, #4f3d2d);
  background: var(--color-wood-800, #2d2218);
}

.ttbButton.matching-prefs__add-button {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 0 var(--space-4, 16px);
  border: 2px solid var(--color-fire-500, #d85a1f);
  border-radius: var(--radius-md, 8px);
  background: var(--color-fire-600, #b8470e);
  color: var(--color-parchment-100, #f5efe7);
  font-family: var(--font-heading, inherit);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: var(--shadow-button, 0 2px 4px rgba(0, 0, 0, 0.25));
  transition: background 0.15s ease;
}

.ttbButton.matching-prefs__add-button:hover:not(:disabled) {
  background: var(--color-fire-500, #d85a1f);
}

.ttbButton.matching-prefs__add-button:disabled {
  opacity: 0.5;
  box-shadow: none;
}

.matching-prefs__chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2, 8px);
}

.matching-prefs__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 2px 4px 2px 10px;
  border-radius: 999px;
  border: 2px solid var(--color-fire-500, #d85a1f);
  background: var(--color-fire-700, #8f3a0b);
  color: var(--color-parchment-100, #f5efe7);
  font-size: 14px;
}

/* No remove button inside: keep the horizontal padding symmetric. */
.matching-prefs__chip--static {
  padding: 4px 10px;
}

.matching-prefs__adders {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2, 8px);
}

.matching-prefs__add {
  flex: 1 1 140px;
  min-width: 0;
}

.matching-prefs__remove {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 4px 6px;
  color: inherit;
}

.matching-window-preview {
  padding: var(--space-2, 8px) var(--space-3, 12px);
  border-radius: var(--radius-md, 8px);
  background: rgba(0, 0, 0, 0.12);
  font-weight: 600;
}

.matching-window-preview--error {
  color: var(--color-danger-500, #c0392b);
}

.matching-forming-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  background: var(--color-warning-500, #d9a520);
  color: #2d1f10;
}
`, "",{"version":3,"sources":["webpack://./src/features/matching/matching.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,0CAA0C;EAC1C,gDAAgD;EAChD,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,wFAAwF;AACxF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB;;2CAEyC;EACzC;;;oBAGkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB;;2CAEyC;AAC3C;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iDAAiD;EACjD,qDAAqD;EACrD,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;EACpD,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;EAChD,+CAA+C;EAC/C,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,kDAAkD;EAClD,qCAAqC;EACrC,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,kDAAkD;EAClD,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,iDAAiD;EACjD,oCAAoC;EACpC,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,gDAAgD;EAChD,oCAAoC;EACpC,0CAA0C;EAC1C,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+DAA+D;EAC/D,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB","sourcesContent":["/* Matching (\"Сбор\") — panel, board card, form pieces. Uses the tavern theme variables. */\n\n.matching-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1, 4px);\n  width: 100%;\n  padding: var(--space-3, 12px) var(--space-4, 16px);\n  text-align: left;\n  font: inherit;\n  color: var(--color-text-primary-light, #f5e9d3);\n  background: var(--color-wood-800, #3a2a18);\n  border: 2px solid var(--color-wood-700, #5a4129);\n  border-radius: var(--radius-lg, 12px);\n  cursor: pointer;\n}\n\n.matching-panel--disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n/* Clickable variant: raised look, chevron and press feedback so it reads as a button. */\n.matching-panel--action {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3, 12px);\n  box-shadow:\n    0 2px 6px rgba(0, 0, 0, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  transition:\n    transform 0.1s ease,\n    box-shadow 0.1s ease,\n    filter 0.1s ease;\n}\n\n.matching-panel__body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1, 4px);\n  min-width: 0;\n}\n\n.matching-panel__chevron {\n  flex-shrink: 0;\n  font-size: 28px;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n@media (hover: hover) {\n  .matching-panel--action:hover {\n    filter: brightness(1.1);\n  }\n}\n\n.matching-panel--action:active {\n  transform: translateY(1px);\n  filter: brightness(0.95);\n  box-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.matching-panel--action:focus-visible {\n  outline: 2px solid var(--color-fire-500, #e8892b);\n  outline-offset: 2px;\n}\n\n.matching-panel--active {\n  border-color: var(--color-fire-500, #e8892b);\n}\n\n.matching-panel--matched {\n  border-color: var(--color-warning-500, #d9a520);\n}\n\n.matching-panel--formed {\n  border-color: var(--color-success-500, #4a9d5b);\n}\n\n.matching-panel__title {\n  font-family: var(--font-heading, inherit);\n  font-weight: 700;\n}\n\n.matching-panel__text {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n/* ---------- request card ---------- */\n\n.matching-card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n  padding: var(--space-3, 12px);\n  color: var(--color-text-primary, #1a1410);\n}\n\n.matching-card__top {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2, 8px);\n}\n\n.matching-card__author {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.matching-card__link {\n  color: var(--color-fire-600, #b8470e);\n  text-decoration: none;\n}\n\n.matching-card__link:hover {\n  text-decoration: underline;\n}\n\n.matching-card__meta {\n  font-size: 13px;\n  color: var(--color-text-secondary, #4f3d2d);\n}\n\n.matching-card__when {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: var(--space-2, 8px);\n}\n\n.matching-card__when .tavern-card-time {\n  flex: 0 1 auto;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.matching-card__when .event-card-actions {\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n\n@media (max-width: 360px) {\n  .matching-card__when .tavern-card-time {\n    padding: 4px 6px;\n    font-size: 12px;\n  }\n}\n\n.matching-card__prefs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n}\n\n.matching-card__pref-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: var(--space-2, 8px) var(--space-3, 12px);\n  border-left: 4px solid var(--color-wood-600, #4f3d2d);\n  border-radius: var(--radius-md, 8px);\n  background: rgba(62, 47, 34, 0.06);\n}\n\n.matching-card__pref-group--want {\n  border-left-color: var(--color-success-500, #4a7c59);\n  background: rgba(74, 124, 89, 0.12);\n}\n\n.matching-card__pref-group--acceptable {\n  border-left-color: var(--color-warning-500, #d4a74a);\n  background: rgba(212, 167, 74, 0.14);\n}\n\n.matching-card__pref-group--exclude {\n  border-left-color: var(--color-danger-500, #a8342a);\n  background: rgba(168, 52, 42, 0.1);\n}\n\n.matching-card__pref-title {\n  font-family: var(--font-heading, inherit);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.matching-card__pref-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2, 8px);\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.matching-card__pref-toggle:focus-visible {\n  outline: 2px solid var(--color-fire-500, #d85a1f);\n  outline-offset: 2px;\n}\n\n.matching-card__pref-count {\n  display: inline-block;\n  margin-left: 8px;\n  min-width: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--color-fire-700, #8f3a0b);\n  color: var(--color-parchment-100, #f5efe7);\n  font-size: 12px;\n  text-align: center;\n}\n\n.matching-card__pref-arrow {\n  flex: 0 0 auto;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.matching-card__pref-hint {\n  font-family: var(--font-body, inherit);\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--color-text-secondary, #4f3d2d);\n}\n\n.matching-card__pref-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.matching-card__pref-section + .matching-card__pref-section {\n  margin-top: var(--space-1, 4px);\n  padding-top: var(--space-2, 8px);\n  border-top: 1px dashed var(--color-wood-600, #4f3d2d);\n}\n\n.matching-card__pref-caption {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-text-secondary, #4f3d2d);\n}\n\n.matching-card__pref-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.matching-card__pref-games {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n}\n\n.matching-card__pref-chip {\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--color-wood-600, #4f3d2d);\n  background: var(--color-parchment-100, #f5efe7);\n  color: var(--color-text-primary, #1a1410);\n  font-size: 13px;\n}\n\n.matching-card__pref-chip--tag {\n  background: var(--color-parchment-200, #e8dbc8);\n  font-style: italic;\n}\n\n.matching-card__actions {\n  display: flex;\n  gap: var(--space-2, 8px);\n  flex-wrap: wrap;\n}\n\n.matching-card__hint {\n  font-size: 13px;\n  color: var(--color-text-secondary, #4f3d2d);\n}\n\n/* ---------- preference picker ---------- */\n\n.matching-prefs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n}\n\n.matching-prefs__summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n  padding: var(--space-3, 12px) var(--space-4, 16px);\n  border-radius: var(--radius-lg, 12px);\n  border: 2px solid var(--color-fire-700, #8f3a0b);\n  background: var(--color-wood-800, #2d2218);\n  color: var(--color-parchment-200, #e8dbc8);\n}\n\n.matching-prefs__summary .ttbFieldLabel {\n  color: var(--color-parchment-100, #f5efe7);\n}\n\n.matching-prefs__summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2, 8px);\n}\n\n.matching-prefs__summary-level {\n  flex: 0 0 96px;\n  font-weight: 700;\n}\n\n.matching-prefs__summary-empty {\n  opacity: 0.6;\n}\n\n.matching-prefs__group {\n  display: flex;\n  flex-direction: column;\n  border: none;\n  border-radius: var(--radius-lg, 12px);\n  background: var(--color-wood-700, #3e2f22);\n  color: var(--color-parchment-200, #e8dbc8);\n  overflow: hidden;\n}\n\n.matching-prefs__group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2, 8px);\n  width: 100%;\n  padding: var(--space-3, 12px) var(--space-4, 16px);\n  border: none;\n  background: var(--color-wood-600, #4f3d2d);\n  color: var(--color-parchment-100, #f5efe7);\n  font: inherit;\n  font-family: var(--font-heading, inherit);\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-align: left;\n  cursor: pointer;\n}\n\n.matching-prefs__group-header:hover {\n  background: var(--color-wood-600, #4f3d2d);\n  box-shadow: inset 0 0 0 100px rgba(245, 239, 231, 0.07);\n}\n\n.matching-prefs__group-header:focus-visible {\n  outline: 2px solid var(--color-fire-500, #d85a1f);\n  outline-offset: -2px;\n}\n\n.matching-prefs__arrow {\n  flex: 0 0 auto;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.matching-prefs__count {\n  display: inline-block;\n  margin-left: 8px;\n  min-width: 22px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--color-fire-700, #8f3a0b);\n  color: var(--color-parchment-100, #f5efe7);\n  font-size: 13px;\n  text-align: center;\n}\n\n.matching-prefs__group-body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3, 12px);\n  padding: var(--space-3, 12px);\n}\n\n.matching-prefs__group .ttbFieldHint,\n.matching-prefs__group .ttbFieldLabel {\n  color: var(--color-parchment-200, #e8dbc8);\n}\n\n.matching-prefs__zone {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n  padding: var(--space-2, 8px) var(--space-3, 12px);\n  border-radius: var(--radius-md, 8px);\n  border: 2px solid var(--color-wood-600, #4f3d2d);\n  background: var(--color-wood-800, #2d2218);\n}\n\n.ttbButton.matching-prefs__add-button {\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 0 var(--space-4, 16px);\n  border: 2px solid var(--color-fire-500, #d85a1f);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-fire-600, #b8470e);\n  color: var(--color-parchment-100, #f5efe7);\n  font-family: var(--font-heading, inherit);\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n  box-shadow: var(--shadow-button, 0 2px 4px rgba(0, 0, 0, 0.25));\n  transition: background 0.15s ease;\n}\n\n.ttbButton.matching-prefs__add-button:hover:not(:disabled) {\n  background: var(--color-fire-500, #d85a1f);\n}\n\n.ttbButton.matching-prefs__add-button:disabled {\n  opacity: 0.5;\n  box-shadow: none;\n}\n\n.matching-prefs__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2, 8px);\n}\n\n.matching-prefs__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  padding: 2px 4px 2px 10px;\n  border-radius: 999px;\n  border: 2px solid var(--color-fire-500, #d85a1f);\n  background: var(--color-fire-700, #8f3a0b);\n  color: var(--color-parchment-100, #f5efe7);\n  font-size: 14px;\n}\n\n/* No remove button inside: keep the horizontal padding symmetric. */\n.matching-prefs__chip--static {\n  padding: 4px 10px;\n}\n\n.matching-prefs__adders {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2, 8px);\n}\n\n.matching-prefs__add {\n  flex: 1 1 140px;\n  min-width: 0;\n}\n\n.matching-prefs__remove {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  padding: 4px 6px;\n  color: inherit;\n}\n\n.matching-window-preview {\n  padding: var(--space-2, 8px) var(--space-3, 12px);\n  border-radius: var(--radius-md, 8px);\n  background: rgba(0, 0, 0, 0.12);\n  font-weight: 600;\n}\n\n.matching-window-preview--error {\n  color: var(--color-danger-500, #c0392b);\n}\n\n.matching-forming-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n  background: var(--color-warning-500, #d9a520);\n  color: #2d1f10;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
